import { render, staticRenderFns } from "./SetContractingItem.vue?vue&type=template&id=0048b2e1&"
import script from "./SetContractingItem.vue?vue&type=script&lang=js&"
export * from "./SetContractingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VListGroup})
